/**
 * Dashboard endpoints — ported queries.py read functions. All cached on the
 * backend (5min TTL mirrors the old @st.cache_data).
 */
import { apiClient } from "@/lib/api-client";
import type { BalanceRow, CurrentWeekRow, EarnedSpentRow, StreakRow, WeekCategoryRow } from "@/api/responses";

/** GET /api/dashboard/balance — get_current_balance. Returns a single-row list; unwrap to the row or null. */
export async function getBalance(): Promise<BalanceRow | null> {
  const rows = await apiClient.get<BalanceRow[]>("/dashboard/balance");
  return rows[0] ?? null;
}

/** GET /api/dashboard/current-week — get_current_week. Returns a single-row list; unwrap to the row or null. */
export async function getCurrentWeek(): Promise<CurrentWeekRow | null> {
  const rows = await apiClient.get<CurrentWeekRow[]>("/dashboard/current-week");
  return rows[0] ?? null;
}

/** GET /api/dashboard/week-categories — get_current_week_categories. */
export function getWeekCategories(): Promise<WeekCategoryRow[]> {
  return apiClient.get<WeekCategoryRow[]>("/dashboard/week-categories");
}

/** GET /api/dashboard/streaks — get_all_streaks (all 7 categories). */
export function getStreaks(): Promise<StreakRow[]> {
  return apiClient.get<StreakRow[]>("/dashboard/streaks");
}

/** GET /api/dashboard/earned-spent — get_weekly_earned_spent (last 12 weeks). */
export function getEarnedSpent(): Promise<EarnedSpentRow[]> {
  return apiClient.get<EarnedSpentRow[]>("/dashboard/earned-spent");
}
